/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 */

import { IAppState } from '../../common/state';

export const NEWBUILDING_TEST_CTR_PARALLAX_IN_TGB_FOOTER = 'newbuilding_test_ctr_parallax_in_tgb_footer';

export function newbuildingTestCtrParallaxInTgbFooterExpGroupSelector(state: IAppState): string | null {
  return (
    state.abUseExperiments.find(e => e.experimentName === NEWBUILDING_TEST_CTR_PARALLAX_IN_TGB_FOOTER)?.groupName ??
    null
  );
}
